import {
	IStepAssignedToUser,
	IStepHistoryComment,
} from "models/StepHistoryDetail";
// export type ChangeOrderRequestButtonModel = {
// 	isApprove: boolean;
// 	isTaskComplete: boolean;
// 	isDelegation: boolean;
// 	isUserCompletedStep: boolean;
// };
// export default class ChangeOrderRequestDetailModel {
// 	changeOrderRequestId: number;
// 	erpDbCompanyId: number;
// 	initiatingDepartmentId: number;
// 	changeOrderRequestStatusId: number;
// 	comment: string;
// 	moduleId: number;
// 	purchaseTypeId: number;
// 	purchaseCategoryId: number;
// 	isProject: boolean;
// 	portfolioId: number | null;
// 	startDate: Date | null;
// 	endDate: Date | null;
// 	reasonCodeIds: number[];
// 	departmentName: string;
// 	changeOrderRequestNumber: string;
// 	requesterId: number;
// 	requesterName: string;
// 	requestedDate: Date | null;
// 	sourceTransactionNumber?: string;
// 	coNumber?: string;
// 	workFlowModulePhaseId?: number;
// 	modulePhaseName?: string;
// 	stepDetail?: any;
// 	changeOrderRequestButtonModel?: ChangeOrderRequestButtonModel | null;

// 	constructor() {
// 		this.changeOrderRequestId = 0;
// 		this.erpDbCompanyId = 0;
// 		this.initiatingDepartmentId = 0;
// 		this.changeOrderRequestStatusId = 0;
// 		this.comment = "";
// 		this.moduleId = 0;
// 		this.purchaseTypeId = 0;
// 		this.purchaseCategoryId = 0;
// 		this.isProject = false;
// 		this.portfolioId = null;
// 		this.startDate = null;
// 		this.endDate = null;
// 		this.reasonCodeIds = [];
// 		this.departmentName = "";
// 		this.changeOrderRequestNumber = "CORXXXXX";
// 		this.requesterId = 0;
// 		this.requesterName = "";
// 		this.requestedDate = null;
// 	}
// }

export default class ChangeOrderRequestDetailModel {
	changeOrderRequestId: number;
	erpDbCompanyId: number;
	initiatingDepartmentId: number;
	changeOrderRequestStatusId: number;
	comment: string;
	moduleId: number;
	purchaseTypeId: number;
	purchaseCategoryId: number;
	isProject: boolean | null;
	portfolioId: number | null;
	startDate: Date | null;
	endDate: Date | null;
	reasonCodeIds: number[];
	departmentName: string;
	changeOrderRequestNumber: string;
	requesterId: number;
	requesterName: string;
	requestedDate: Date | null;
	budgetChangeTypeId?: number | null;
	budgetChangeTypeName?: string | null;

	sourceTransactionId?: number;
	sourceTransactionNumber?: string;

	stepDetail?: ChangeOrderRequestStepDetails;
	changeOrderRequestActionButtonModel?: ChangeOrderRequestActionButtonModel;

	workFlowModulePhaseId?: number;
	modulePhaseName?: string;
	coNumber?: string;

	constructor() {
		this.changeOrderRequestId = 0;
		this.erpDbCompanyId = 0;
		this.initiatingDepartmentId = 0;
		this.changeOrderRequestStatusId = 0;
		this.comment = "";
		this.moduleId = 0;
		this.purchaseTypeId = 0;
		this.purchaseCategoryId = 0;
		this.isProject = false;
		this.portfolioId = null;
		this.startDate = null;
		this.endDate = null;
		this.reasonCodeIds = [];
		this.departmentName = "";
		this.changeOrderRequestNumber = "CORXXXXX";
		this.requesterId = 0;
		this.requesterName = "";
		this.requestedDate = null;
		this.budgetChangeTypeId = null;
		this.budgetChangeTypeName = null;

		this.sourceTransactionId = undefined;
		this.sourceTransactionNumber = undefined;

		this.stepDetail = undefined;
		this.changeOrderRequestActionButtonModel = undefined;

		this.workFlowModulePhaseId = undefined;
		this.modulePhaseName = undefined;
		this.coNumber = undefined;
	}
}
export class ChangeOrderRequestStepDetails {
	changeOrderRequestStepId: number;
	stepNumber: string;
	sequenceNumber: number;
	changeOrderRequestStepStatusId: number;
	isRecall: boolean;
	modulePhaseId: number;
	isTransferOrAdjustmentDone?: boolean;
	isLastStep?: boolean;

	constructor() {
		this.changeOrderRequestStepId = 0;
		this.stepNumber = "";
		this.sequenceNumber = 0;
		this.changeOrderRequestStepStatusId = 0;
		this.isRecall = false;
		this.modulePhaseId = 0;
		this.isLastStep = false;
	}
}

export class ChangeOrderRequestActionButtonModel {
	isApprove: boolean;
	isTaskComplete: boolean;
	isDelegation: boolean;
	isUserCompletedStep: boolean;
	isSubmitToFinance?: boolean;
	isPreviousStepDelegated: boolean;

	constructor() {
		this.isApprove = false;
		this.isTaskComplete = false;
		this.isDelegation = false;
		this.isUserCompletedStep = false;
		this.isSubmitToFinance = false;
		this.isPreviousStepDelegated = false;
	}
}

export interface ChangeOrderRequestSaveModel {
	changeOrderRequestId: number;
	erpDbCompanyId: number;
	initiatingDepartmentId: number;
	changeOrderRequestStatusId: number;
	comment: string;
	moduleId: number;
	purchaseTypeId: number;
	purchaseCategoryId: number;
	isProject: boolean;
	portfolioId: number | null;
	startDate: Date | string | null;
	endDate: Date | string | null;
	reasonCodeIds: number[];
	budgetChangeTypeId?: number | null;
}

export class GLAccountDetailModel {
	glAccount: string;
	glCategory: string;
	description: string;

	constructor() {
		this.glAccount = "";
		this.glCategory = "";
		this.description = "";
	}
}

export class CORequestLineFinancialYearDetail {
	changeOrderRequestLineDetailId?: number = undefined;
	financialYearId: number = -1;
	financialYear: string = "";
	qty: number | null = null;
	estUnitCost: number | null = null;
	vatAmount: number | null = 0;
	subTotal: number | null = 0;
	totalEstCost: number | null = 0;

	submitedAvailableBudgetAmount: number | null = null;
	submitedRemainingBudgetAmount: number | null = null;
	submitedRequiredBudgetAmount: number | null = null;
	changeOrderAmount?: number = undefined;
	budgetAvailable?: number = undefined;
}

/* CO request line */
export class CORequestLineModel {
	changeOrderRequestLineId?: number;
	changeOrderRequestId: number;
	programmeId: number | null;
	departmentId: number | null;
	itemId: number | null;
	changeOrderLineDescription: string;
	qty: number | null;
	estUnitCost: number | null;
	subTotal: number;
	baseLineAmount: number;
	changeOrderAmount: number;
	glAccountId: number;
	glAccountName?: string;
	glDescription?: string | null;
	glCategoryName?: string;
	fromFinancialYearId: number | null;
	toFinancialYearId: number | null;
	fromFinancialYear?: string;
	toFinancialYear?: string;
	vatAmount: number;
	totalEstCost: number;
	csdCommodityId: number | null;
	projectId: number | null;
	portfolioOrganizationUnitId?: number | null;
	projectOrganizationUnitId?: number | null;
	costCategoryId: number | null;
	createdDate: Date;
	changeOrderRequestLineDetailList: CORequestLineFinancialYearDetail[];

	divisionId?: number | null;
	subDivisionId?: number | null;
	regionId?: number | null;
	subRegionId?: number | null;
	departmentInstanceId?: number | null;
	subDepartmentId?: number | null;

	glAccountDetail?: GLAccountDetailModel | null;
	itemUomName?: string;
	itemAvailabilityId?: number;
	submitedAvailableBudgetAmount?: number | null;
	submitedRemainingBudgetAmount?: number | null;
	submitedRequiredBudgetAmount?: number | null;
	submitedAvailableQuantity?: number | null;
	submitedRemainingQuantity?: number | null;
	submitedRequiredQuantity?: number | null;

	constructor() {
		this.changeOrderRequestLineId = undefined;
		this.changeOrderRequestId = 0;
		this.programmeId = null;
		this.departmentId = null;
		this.itemId = null;
		this.changeOrderLineDescription = "";
		this.qty = null;
		this.estUnitCost = null;
		this.subTotal = 0;
		this.baseLineAmount = 0;
		this.changeOrderAmount = 0;
		this.glAccountId = 0;
		this.glAccountName = "";
		this.glDescription = null;
		this.glCategoryName = "";
		this.fromFinancialYearId = null;
		this.toFinancialYearId = null;
		this.fromFinancialYear = "";
		this.toFinancialYear = "";
		this.vatAmount = 0;
		this.totalEstCost = 0;
		this.csdCommodityId = null;
		this.projectId = null;
		this.portfolioOrganizationUnitId = null;
		this.projectOrganizationUnitId = null;
		this.costCategoryId = null;
		this.createdDate = new Date();
		this.changeOrderRequestLineDetailList = [];

		this.divisionId = null;
		this.subDivisionId = null;
		this.regionId = null;
		this.subRegionId = null;
		this.departmentInstanceId = null;
		this.subDepartmentId = null;
	}
}

export interface CORequestLineDetailRequest {
	changeOrderRequestLineDetailId?: number;
	financialYearId: number;
	qty: number;
	estUnitCost: number;
}

export interface SaveOrUpdateCORequestLineRequest {
	changeOrderRequestLineId?: number;
	changeOrderRequestId: number;
	programmeId: number;
	departmentId: number;
	itemId: number;
	changeOrderLineDescription: string;
	glAccountId: number;
	fromFinancialYearId: number;
	toFinancialYearId: number;
	qty: number;
	estUnitCost: number;
	subTotal: number;
	baseLineAmount: number;
	changeOrderAmount: number;
	csdCommodityId: number | null;
	changeOrderRequestLineDetailList: CORequestLineDetailRequest[];
	projectId: number | null;
	costCategoryId: number | null;

	divisionId?: number | null;
	subDivisionId?: number | null;
	regionId?: number | null;
	subRegionId?: number | null;
	departmentInstanceId?: number | null;
	subDepartmentId?: number | null;
	portfolioOrganizationUnitId?: number | null;
	projectOrganizationUnitId?: number | null;
}

export interface IChangeOrderRequestLineYearDetail {
	changeOrderRequestLineDetailId: number;
	financialYearId: number;
	financialYear: string;
	baseLine: number;
	changeOrder: number;
	forecast: number;
	requisition: number;
	sourcing: number;
	contracts: number;
	purchaseOrders: number;
	unpaidExpenses: number;
	paidExpenses: number;
	budgetAvailable: number;
	requestedAmount: number;
	allocatedAmount: number;
	isTransferPhase: boolean;
	isAdjustmentPhase: boolean;
	transferDoneByUserId: number | null;
	adjustmentDoneByUserId: number | null;
	variance: number;
}

export interface IChangeOrderRequestLineListItem {
	changeOrderRequestLineId: number;
	programme: string;
	department: string;
	item: string;
	glAccount: string;
	isAttachments: boolean;
	changeOrderRequestLineDetails: IChangeOrderRequestLineYearDetail[];
}

export interface IReqItemExistModel {
	changeOrderRequestId: number;
	itemId: number;
	buyingDepartmentId: number;
	csdCommodityId: number;
	transactionTypeId: number;
	contractId: number;
	productDescription: string;
	contractLineId: number;
	changeOrderRequestLineId: number;
	isCompanyWideItem: boolean;
	projectId: number | null;
	costCategoryId: number | null;
}

export interface AddUpdateBudgetCOrequest {
	coRequestLineDetailId: number;
	changeOrderAmount: number;
}

export type CORequestFinYearAttachmentType = {
	changeOrderRequestLineId: number;
	changeOrderRequestNumber: string;
	isAttachmentViewOnly: boolean;
};

export interface IChangeOrderItemExistModel {
	changeOrderRequestId: number;
	itemId: number;
	departmentId: number;
	description: string;
	projectId: number | null;
	costCategoryId: number | null;
	changeOrderRequestLineId: number;
}

export interface IChangeOrderRequestGridDetail {
	requestNumber: string;
	coNumber: string | null;
	orgTransactionNumber: string;
	department: string;
	origin: string;
	requestor: string;
	request: string;
	date: string;
	requestedAmount: number | null;
	phase: string | null;
	statusId: number;
	rowNumber: number;
	totalRows: number;
	changeOrderRequestId: number;
	status: string;
	allocatedAmount: number;
	budgetAvailable: number;

	isCreatedByMe: boolean;
	isCreate: boolean;
	isRecall: boolean;
	readyStepDetail: ReadyStepDetail;
}

export interface IChangeOrderRequestLineAttachment {
	changeOrderRequestLineAttachmentId: number;
	documentFileName: string;
	documentDescription: string;
	documentFilePath: string;
	financialYear?: string | null;
}

export interface IFinancialYearDetailForCORequest {
	financialYearId: number;
	financialYear: string;
}

export interface IFinancialYearForCORequest {
	fromFinancialYear: IFinancialYearDetailForCORequest;
	toFinancialYear: IFinancialYearDetailForCORequest;
	financialYearList: IFinancialYearDetailForCORequest[];
}

export type IFinYearCORequestError = {
	index: number;
	qty: string;
	estUnitCost: string;
};

export type CORequestLineFinYearAttachmentType = {
	contractLineId: number;
	requestNumber: string;
	isAttachmentViewOnly: boolean;
	isMilestoneViewOnly: boolean;
};
export interface CheckItemExistRequest {
	changeOrderRequestId: number;
	itemId: number;
	departmentId: number;
	description: string;
	projectId: number | null;
	portfolioOrganizationUnitId?: number | null;
	projectOrganizationUnitId?: number | null;
	costCategoryId: number | null;
	changeOrderRequestLineId: number;
	divisionId?: number | null;
	regionId?: number | null;
	subDivisionId?: number | null;
	subRegionId?: number | null;
	departmentInstanceId?: number | null;
	subDepartmentId?: number | null;
}
export interface CheckItemExistResponse {
	isItemAlreadyExist: boolean;
}

/*** Change Order request workflow step history and actions */

export class ChangeOrderRequestStepHistoryEmitter {
	changeOrderRequestId: number;
	changeOrderRequestStepId: number;
	actionType: string;

	constructor() {
		this.changeOrderRequestId = -1;
		this.changeOrderRequestStepId = -1;
		this.actionType = "";
	}
}

export type ReadyStepDetail = {
	changeOrderRequestStepId: number;
	changeOrderRequestStepStatusId: number;
	stepNumber: string;
	sequenceNumber: number | null;
	isAssigned: boolean;
	isApprove: boolean;
	isDelegation: boolean;
	isTaskComplete: boolean;
	isSubmitToFinance?: boolean;
	isUserCompletedStep: boolean;
	isShowProcurementMethodSelection: boolean;
	isLastStep?: boolean;
};

export type ApprovedChangeOrderRequestDetail = {
	changeOrderRequestId: number;
	changeOrderRequestNumber: string;
	contractTypeId: number;
	erpDbCompanyId: number;
	purchaseCategoryId: number;
	purchaseTypeId: number;
	changeOrderRequestTypeId: number;
	transactionTypeId: number | null;
	status: string;
	procurementMethodCount: number;
	reasonCodeId: number;
	departmentIds: number[];
};

export class ReadyStatusChangeOrderRequestDetail {
	changeOrderRequestId: number;
	changeOrderRequestStepId: number;
	stepNumber: string;
	sequenceNumber: number;
	requestNumber: string;
	// changeOrderRequestNumber: string;
	description: string;
	companyAbbreviation?: string;

	constructor() {
		this.changeOrderRequestId = 0;
		this.changeOrderRequestStepId = 0;
		this.stepNumber = "";
		this.sequenceNumber = 0;
		this.requestNumber = "";
		// this.changeOrderRequestNumber = "";
		this.description = "";
		this.companyAbbreviation = "";
	}
}

export class CORequestConfirmationModel {
	comment: string;
	changeOrderRequestStepId?: number | null;
	delegationToUser?: number | null;

	constructor() {
		this.comment = "";
		this.changeOrderRequestStepId = null;
		this.delegationToUser = null;
	}
}

export interface ICORequestLineTransfer {
	coRequestLineId: number;
	quantity: number;
	itemId: number;
	itemName: string;
	buyingDepartmentName: string;
	inventoryNumber: string;
}

export class CORequestLineTransferDetail {
	rowCount: number = 0;
	coRequestLineTransfers: ICORequestLineTransfer[] = [];
}

export interface IPreviousCORequestStepHistory {
	changeOrderRequestStepId: number;
	stepNumber: number;
	sequenceNumber: number;
	description: string;
	assignedToUsers: string | null;
	assignedToGroups?: string | null;
}

export interface ICORequestAttachment {
	changeOrderRequestAttachmentId: number;
	documentFileName: string;
	documentDescription: string;
	documentFilePath: string;
	stepNumber?: number | null;
	sequenceNumber?: number | null;
}

export interface ICompletedStepHistory {
	changeOrderRequestStepId: number;
	stepNumber: number;
	sequenceNumber: number;
}

export interface IChangeOrderRequestStepHistory {
	changeOrderRequestId: number;
	stepStatus: string;
	changeOrderRequestStepId: number;
	stepNumber: string;
	description: string;
	assignToUsers: IStepAssignedToUser[];
	duration: string;
	averageDuration: string;
	completedDate?: Date;
	completedBy: string;
	stepCompletedInPercentage: number;
	comments: IStepHistoryComment[];
	modulePhaseId: number;
}

export interface IUpdateChangeOrderRequestStepApproveResult {
	isThisLastStep: boolean;
	isReadyStatusAllTaskCompleted?: boolean;
}

export interface ICopyCORResult {
	newCORId: number;
	requestNumber: string;
}
